import { CONTACT_EMAIL } from "../../utils/constants";

function Footer() {
  return (
    <div className="footer">
      <nav className="footer-links" aria-label="Liens sociaux">
        <ul>
          <li>
            <a
              href="https://github.com/yanisdjr38"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/yanis-djouahra/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </li>
          <li>
            <a href={`mailto:${CONTACT_EMAIL}`}>Mail</a>
          </li>
        </ul>
      </nav>
      <p>&copy; 2026 Yanis Djouahra — Développeur web freelance.</p>
    </div>
  );
}

export default Footer;
